// Position-to-position associations for the Paths ego-graph.
//
// Each link connects two category (position) ids. `label` is the relationship /
// transition shown on the edge. `bidirectional: true` means the flow reads both
// ways (mirrors like DLR/RDLR, or pass-vs-retain pairs); otherwise the arrow
// points from → to.
//
// This is curated BJJ domain content — edit freely. Category ids must match
// src/data/categories.ts. Unknown ids are ignored at render time.
export interface PositionLink {
  from: string;
  to: string;
  label: string;
  bidirectional?: boolean;
}

export const positionLinks: PositionLink[] = [
  // ── Fundamentals / positional ──
  { from: 'standing', to: 'closed-guard', label: 'pull / stand', bidirectional: true },
  { from: 'closed-guard', to: 'half-guard', label: 'transition', bidirectional: true },
  { from: 'closed-guard', to: 'back-control', label: 'back take' },
  { from: 'side-control', to: 'mount', label: 'mount', bidirectional: true },
  { from: 'side-control', to: 'back-control', label: 'back take' },
  { from: 'mount', to: 'back-control', label: 'back take' },
  { from: 'side-control', to: 'closed-guard', label: 'recover guard' },
  { from: 'mount', to: 'half-guard', label: 'recover guard' },
  { from: 'turtle', to: 'back-control', label: 'take the back', bidirectional: true },
  { from: 'turtle', to: 'side-control', label: 'flatten / escape', bidirectional: true },
  { from: 'turtle', to: 'half-guard', label: 'recover guard' },
  { from: 'turtle', to: 'crucifix', label: 'trap arm → crucifix' },
  { from: 'crucifix', to: 'back-control', label: 'to back', bidirectional: true },

  // ── Seated & open guards ──
  { from: 'half-guard', to: 'dlr', label: 'transition', bidirectional: true },
  { from: 'half-guard', to: 'butterfly-guard', label: 'transition', bidirectional: true },
  { from: 'half-guard', to: 'worm-guard', label: 'lapel entry', bidirectional: true },
  { from: 'butterfly-guard', to: 'seated-guard', label: 'transition', bidirectional: true },
  { from: 'butterfly-guard', to: 'x-guard', label: 'elevate to X' },
  { from: 'seated-guard', to: 'spider-lasso', label: 'transition', bidirectional: true },

  // ── Leg-entanglement / modern open guard ──
  { from: 'dlr', to: 'rdlr', label: 'mirror', bidirectional: true },
  { from: 'dlr', to: 'x-guard', label: 'to X-guard', bidirectional: true },
  { from: 'dlr', to: 'slx', label: 'to single-leg X', bidirectional: true },
  { from: 'dlr', to: 'spider-lasso', label: 'transition', bidirectional: true },
  { from: 'dlr', to: 'back-control', label: 'back take' },
  { from: 'rdlr', to: 'crab-ride', label: 'to crab ride', bidirectional: true },
  { from: 'rdlr', to: 'back-control', label: 'back take' },
  { from: 'x-guard', to: 'slx', label: 'variant', bidirectional: true },
  { from: 'k-guard', to: 'x-guard', label: 'transition', bidirectional: true },
  { from: 'k-guard', to: 'slx', label: 'to single-leg X' },
  { from: 'k-guard', to: 'back-control', label: 'leg entry → back' },
  { from: 'slx', to: 'back-control', label: 'back take' },
  { from: 'crab-ride', to: 'back-control', label: 'ride to back' },
  { from: 'slx', to: 'fifty-fifty', label: 'transition', bidirectional: true },
  { from: 'k-guard', to: 'fifty-fifty', label: 'leg entry' },
  { from: 'fifty-fifty', to: 'back-control', label: 'back take' },

  // ── Lapel & specialty ──
  { from: 'berimbolo', to: 'fifty-fifty', label: 'bolo → 50/50', bidirectional: true },
  { from: 'berimbolo', to: 'worm-guard', label: 'lapel family', bidirectional: true },
  { from: 'worm-guard', to: 'dlr', label: 'lapel + DLR', bidirectional: true },

  // ── Retention ──
  { from: 'retention', to: 'dlr', label: 'recover guard' },
  { from: 'retention', to: 'half-guard', label: 'recover guard' },
];
